/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Po_Changes_InvalidInputs */

const en_error_po_changes_invalid = /** @type {(inputs: Error_Po_Changes_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some proposals cannot be taken.`)
};

/**
* | output |
* | --- |
* | "Some proposals cannot be taken." |
*
* @param {Error_Po_Changes_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_po_changes_invalid = /** @type {((inputs?: Error_Po_Changes_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Po_Changes_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_po_changes_invalid(inputs)
});